module.exports = __webpack_public_path__ + "static/media/art_hdr.82256bae.jpg";